import React, { PureComponent } from 'react';
import Moment from "moment";
import "moment/min/locales";
import CONSTANTS from '../../constants';
import fetchApiData from '../apiHandlers/fetchApiData'
import TimeLineCalendar from '../TimeLineCalendar/TimeLineCalendar';

import Calendar from 'react-widgets/lib/Calendar';
import momentLocalizer from 'react-widgets-moment';

import 'react-widgets/dist/css/react-widgets.css';
import './dealer-block.css';
import { connect } from 'react-redux';


const DTAE_FORMAT = 'DD/MM/YYYY'
// const mapStateToProps = state => state
class DealerBlock extends PureComponent {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            showMoreButton: false,
            showWidget: false,
            selectedDate: null,
            showFiltersPCLCV: false,
            timeLineData: [],
            isTimeLineDataReady: false,
            dealerID: null,
            CalendarBodyHeight: [],
        };
        this.showMoreButtonHandler = this.showMoreButtonHandler.bind(this);
        this.updateTimeLineCalendar = this.updateTimeLineCalendar.bind(this);
        this.getCalendarBodyHeight = this.getCalendarBodyHeight.bind(this);
        this.dealerBlockDiv = null;
        this.showMoreButtonClicked = false;
        this.moreDealers = this.props.isPageSolo ? !!Number(window.siteConfig.ActivateMOREDEALERSbtn) : true;

    }
    componentWillMount() {
        this._isMounted = true;

        // Force moment to use a certain language on date display
        Moment.locale(window.siteConfig['language']);
        momentLocalizer();


    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    showMoreButtonHandler() {
        //Click sur CTA "Voir plus de crénaux"
        window.dataLayer.push({
            'pageName': 'multicréneaux',
            'event': 'uaevent',
            'eventCategory': 'Content',
            'eventAction': 'Display::Timeslots',
            'eventLabel': (this.state.showMoreButton ? CONSTANTS.LABELS.multislots_see_less_slots : CONSTANTS.LABELS.multislots_see_more_slots)
        });

        this.setState({ showMoreButton: !this.state.showMoreButton });
        if (this.props.opendDealerBlockID) {
            this.props.opendDealerBlockID(this.state.dealerID);
        }
    }
    showCallendarWidget() {
        //this.setState({showWidget : true});
        this.setState({ showWidget: !this.state.showWidget });
    }
    /*hideCallendarWidget(){
         this.setState({showWidget : false});
    }*/
    componentDidMount() {
        this.setState({
            'showMoreButton': (this.props.dealerOpen ?
                this.props.dealerOpen
                :
                this.state.showMoreButton),
            'selectedDate': new Date(),
            'dealerID': this.props.dealerID,
        });
        this.setState({
            showFiltersPCLCV: this.props.listPremiumServices.some(item =>
                (item.codeIntern === 'PC' || item.codeIntern === 'LCV') && item.displayDL)
        })
        this.updateTimeLineCalendar(new Date());
        this.dealerBlockDiv = React.createRef();
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.state.showMoreButton === true && this.state.CalendarBodyHeight) {
            const clientHeight = this.state.CalendarBodyHeight.clientHeight;
            if (!this.isMobile) { this.dealerBlockDiv.current.style.height = clientHeight + 140 + 'px'; }
            else { this.dealerBlockDiv.current.style.height = clientHeight + 240 + 'px'; }
        }
        //console.log(this.state.dealerID+' : '+this.props.dealerOpen);
        if (this.props.dealerOpen == "false") { this.setState({ 'showMoreButton': false }); }
        if (this.props.dealerOpen == "true") { this.setState({ 'showMoreButton': true }); }
    }
    isMobile() {
        if (window.innerWidth <= 800) {
            return true;
        } else {
            return false;
        }
    }
    updateTimeLineCalendar(newDate) {
        if (Moment(newDate).isSameOrBefore()) {
            newDate = Moment().format();
        } else {
            window.dataLayer.push({
                'pageName': 'multicréneaux',
                'event': 'uaevent',
                'eventCategory': 'Content',
                'eventAction': 'Display::Dates',
                'eventLabel': newDate
            });
            console.log('~~ [dealerBlock] ARROW CLICKED : Creneaux loads  , date paramettre :' + Moment(newDate).format())

        }

        const listDealers = new fetchApiData();

        listDealers.getCalendar(this.props.dealerID, newDate).then(
            res => {
                if (this._isMounted) {
                    if (process.env.NODE_ENV !== 'production') {
                        this.setState({
                            'timeLineData': res.d[0].days,
                            'selectedDate': new Date(newDate)
                        });
                    } else {
                        if (JSON.parse(res.d).length > 0 && JSON.parse(res.d)[0] !== undefined) {
                            this.setState({
                                'timeLineData': JSON.parse(res.d)[0].days,
                                'selectedDate': new Date(newDate)
                            });
                        }
                    }

                    this.setState({ 'isTimeLineDataReady': true })
                    if (this.state.timeLineData.length > 4) { this.setState({ 'selectedDate': Moment(this.state.timeLineData[3].dayDate, DTAE_FORMAT).format() }); }
                    else if (this.state.timeLineData.length > 0) { this.setState({ 'selectedDate': Moment(this.state.timeLineData[this.state.timeLineData.length - 1].dayDate, DTAE_FORMAT).format() }); }
                }

            },
            error => {
                this.setState({ 'timeLineData': {}, 'selectedDate': new Date(newDate) });
                console.error(error);
            });
    }
    nextPrevWeek(date, steps) {
        console.log(Moment(date).format());
        this.setState({ 'isTimeLineDataReady': false });
        if (steps == 'next') {
            //Click sur ">" flèche droite 
            window.dataLayer.push({
                'pageName': 'multicréneaux',
                'event': 'uaevent',
                'eventCategory': 'Content',
                'eventAction': 'Display::Timeslots::NextDays',
                'eventLabel': "Next"
            });
        }
        const addDays = (steps === 'next' ? 1 : -5);
        if (steps !== 'next') { date = Moment(this.state.timeLineData[0].dayDate, DTAE_FORMAT).format(); }
        this.updateTimeLineCalendar(Moment(date).add(addDays, 'days').format());
    }
    getCalendarBodyHeight(el) {

        this.setState({
            CalendarBodyHeight: el
        });
    }
    handleMouseOver = () => {
        if (window.siteConfig.ActivateFocusMap == true) {
            this.props.dealerMouseOver(this.props.dealerID)
        }
    }
    handleMouseOut = () => {
        if (window.siteConfig.ActivateFocusMap == true) {
            this.props.dealerMouseOut(this.props.dealerID)
        }
    }
    render() {
        let locationMarkup = "";
        if (this.props.dealerDistance) {
            locationMarkup = <div> <i className="mark-icons location-icon"></i> {this.props.dealerDistance} Km</div>;
        }

        return (
            <div
                data-id={this.state.dealerID}
                className={"dealer-block mark-style view-" + (this.state.showMoreButton ? "maximal" : "minimal")}
                tabIndex="0"

                ref={this.dealerBlockDiv}
                onMouseEnter={this.handleMouseOver}
                onFocus={this.handleMouseOver}
                onBlur={this.handleMouseOut}
                onMouseLeave={this.handleMouseOut}
            >
                <div className="dealer-infos half-block">
                    <div className="dealer-infos--content">
                        <h3 className="dealer-name">{this.props.dealerName}</h3>
                        <span className="dealer-distance">
                            {locationMarkup}
                        </span>
                        <p className="dealer-adress">
                            {this.props.dealerAdress} <br />
                            {this.props.dealerZipCode} {this.props.dealerCity}
                        </p>
                        {this.state.showFiltersPCLCV && <div className='dealer-service'>
                            {(this.props.dealerLCV || this.props.dealerPC) && <i className='mark-icons info-icon' />}
                            <div>
                                {(this.props.dealerPC && !this.props.dealerLCV) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_descriptive}</p>}
                                {(this.props.dealerLCV && !this.props.dealerPC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_lcv_descriptive}</p>}
                                {(this.props.dealerLCV && this.props.dealerPC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_lvc_descriptive}</p>}
                            </div>
                        </div>}
                    </div>
                </div>
                <TimeLineCalendar data={this.state.timeLineData}
                    isTimeLineDataReady={this.state.isTimeLineDataReady}
                    mounthNumber={new Date(this.state.selectedDate)}
                    headerArrowWeek={this.nextPrevWeek.bind(this)}
                    calendarBodyElement={this.getCalendarBodyHeight}
                    dealerID={this.props.dealerGeoId}
                    {...this.props}
                />
                <div className={window.siteConfig.currentBrand == 'C' ? 'dealer-show-more dealer-block-footer ' +
          (this.state.timeLineData.length < 1 ||
            typeof (this.state.timeLineData[0]) !== 'undefined' &&
            this.state.timeLineData[0].hours.length < 1
            ?  ' unavailable-dealer-button ' : '') : "dealer-show-more dealer-block-footer"}>
                    {this.moreDealers &&
                        <button className="show-more-details"
                            tabIndex='0'
                            onClick={this.showMoreButtonHandler}>
                            {/* onFocus={this.showMoreButtonHandler} > */}
                            <p className="show-more-details--title">
                                {this.state.showMoreButton ? CONSTANTS.LABELS.multislots_see_more_slots : CONSTANTS.LABELS.multislots_see_less_slots}
                            </p>
                        </button>}
                    <div className="show-callendar" /*onMouseLeave={this.hideCallendarWidget.bind(this)}*/>
                        {this.state.showWidget && <Calendar
                            value={new Date(this.state.selectedDate)}
                            dayComponent={({ date, label }) => (
                                <div className={date < Moment().add(-1, 'days') ? 'rw-cell-fromPast' : ''}>
                                    {label}
                                </div>)}
                            footer={false}
                            culture={window.siteConfig['language']}
                            onChange={(value) => { this.updateTimeLineCalendar(value); this.setState({ 'showWidget': false, 'isTimeLineDataReady': false }) }}
                            style={{height : window.isMobile() == 'mobile' ? CONSTANTS.SITE_INFO.BRAND_CODE === "C" && this.state.showFiltersPCLCV ? "323px" : "411px" : undefined}}
                        />}
                        <button className="show-callendar--title" tabIndex='0' onClick={this.showCallendarWidget.bind(this)} >
                            <span>{CONSTANTS.LABELS.multislots_choose_another_date}</span>
                            <i className="mark-icons date-icon"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

DealerBlock.defaultProps = {
    isPageSolo: false
}

export default DealerBlock;
